"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const tslib_1 = require("tslib");
const immer_1 = tslib_1.__importDefault(require("immer"));
const getState_1 = require("../../helpers/getState");
const isEmptyObject_1 = tslib_1.__importDefault(require("../../helpers/isEmptyObject"));
const setVersionIdOfState_1 = tslib_1.__importDefault(require("../../helpers/versions/setVersionIdOfState"));
const entity_1 = require("../../type/entity");
const assignmentCardZeroState_1 = tslib_1.__importDefault(require("../../zeroStates/nodeZeroState/assignmentCardZeroState"));
const assignmentQuestionZeroState_1 = tslib_1.__importDefault(require("../../zeroStates/nodeZeroState/assignmentQuestionZeroState"));
const cardQuestionForReviewZeroState_1 = tslib_1.__importDefault(require("../../zeroStates/nodeZeroState/cardQuestionForReviewZeroState"));
const courseZeroState_1 = tslib_1.__importDefault(require("../../zeroStates/nodeZeroState/courseZeroState"));
const learningCardZeroState_1 = tslib_1.__importDefault(require("../../zeroStates/nodeZeroState/learningCardZeroState"));
const peerReviewCardZeroState_1 = tslib_1.__importDefault(require("../../zeroStates/nodeZeroState/peerReviewCardZeroState"));
const sectionZeroState_1 = tslib_1.__importDefault(require("../../zeroStates/nodeZeroState/sectionZeroState"));
const addAssignEvent_1 = tslib_1.__importDefault(require("./addAssignEvent"));
const updateEnrolments_1 = tslib_1.__importDefault(require("./updateEnrolments"));
function applyAssignOffer(command, user, content, states, enrolments, stateInteractions) {
    let updatedStates = states;
    const updatedStateInteractions = stateInteractions;
    let updatedEnrolments = enrolments;
    const newEvents = [];
    const contentType = content.offerType;
    updatedStates = immer_1.default(updatedStates, draftStates => {
        let state = {};
        let existingState = getState_1.getStateByContentIdUserId(draftStates, content._id, user.userId);
        if (existingState) {
            // do nothing just update enrolment if type is course
            if (contentType === entity_1.ContentType.COURSE) {
                updatedEnrolments = updateEnrolments_1.default(enrolments, command, content, user);
                const diffEnrolments = updatedEnrolments.filter((enrolment, index) => {
                    if (enrolment !== enrolments[index]) {
                        return enrolment;
                    }
                });
                if (diffEnrolments.length > 0) {
                    addAssignEvent_1.default(command, updatedEnrolments, user, content, newEvents);
                }
            }
        }
        else {
            switch (contentType) {
                case entity_1.ContentType.LEARNING_CARD:
                    state = learningCardZeroState_1.default(content, user);
                    break;
                case entity_1.ContentType.ASSIGNMENT_CARD:
                    state = assignmentCardZeroState_1.default(content, user);
                    break;
                case entity_1.ContentType.CARD_QUESTION:
                    state = assignmentQuestionZeroState_1.default(content, user);
                    break;
                case entity_1.ContentType.PEER_REVIEW_CARD:
                    state = peerReviewCardZeroState_1.default(content, user);
                    break;
                case entity_1.ContentType.CARD_QUESTION_FOR_REVIEW:
                    state = cardQuestionForReviewZeroState_1.default(content, user);
                    break;
                case entity_1.ContentType.SECTION:
                    state = sectionZeroState_1.default(content, user);
                    break;
                case entity_1.ContentType.COURSE: {
                    state = courseZeroState_1.default(content, user);
                    updatedEnrolments = updateEnrolments_1.default(enrolments, command, content, user);
                    addAssignEvent_1.default(command, updatedEnrolments, user, content, newEvents);
                    break;
                }
                default:
                    break;
            }
            if (!isEmptyObject_1.default(state)) {
                existingState = state;
                draftStates.push(state);
            }
        }
        // update versionId in state
        setVersionIdOfState_1.default(command, content, existingState);
    });
    return {
        events: newEvents,
        states: updatedStates,
        stateInteractions: updatedStateInteractions,
        enrolments: updatedEnrolments
    };
}
exports.applyAssignOffer = applyAssignOffer;
//# sourceMappingURL=applyAssignOffer.js.map